import OaApiService from './OaApiService';

export default class PostcodeService extends OaApiService {
  find(identifier) {
    return this.get('/PostcodeREST/find', null, identifier);
  }

  getDetails(identifier) {
    return this.get('/PostcodeREST', null, identifier);
  }

  getMetadata(postcodeId) {
    return this.get(`/PostcodeREST/${postcodeId}/metadata`);
  }
}
